module.exports = __webpack_public_path__ + "img/27.0f060819.jpg";